import { render, staticRenderFns } from "./platformList.vue?vue&type=template&id=75b44274"
import script from "./platformList.vue?vue&type=script&lang=js"
export * from "./platformList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports